<template>
  <div class="hello">
    <div class="slides-container">
      <div class="slide" :style="{
        position: 'absolute',
        top: 0,
        backgroundImage: `linear-gradient(-90deg, #00000000 0%, #000 60%), url(${require('@/assets/b02.webp')})`
      }">
        <div class="t">
          <h1 class="title">Guincho 24 Horas<br> <span class="title">Atendimento Rápido, Seguro e Pelo Melhor Preço!</span></h1>
          <p>
            Precisa de guincho agora? Oferecemos suporte imediato em todos os bairros com total profissionalismo e transparência. Chame agora e resolvemos para você!
          </p>
          <div class="cont">
            <a target="_blank"
              href="https://api.whatsapp.com/send?phone=5508006544444&amp;text=Olá%20Guincho%20Mais%20Proximo,%20Gostaria%20de%20solicitar%20um%20orçamento."
              class="btn b1">
              <img class="icon32" width="24" height="24" :src="require('@/assets/whatsapp-32.svg')" alt="whatsapp">
              CHAME NO WHATSAPP
            </a>
          </div>
        </div>
        <div id="circulo-banner" class="banner-container">
            <svg class="rotate" version="1.1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="300px" height="300px"
              viewBox="0 0 300 300" enable-background="new 0 0 300 300" xml:space="preserve">
              <defs>
                <path id="circulo-rotativo-banner" d="M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0">
                </path>
              </defs>
              <circle cx="150" cy="100" r="75" fill="none"></circle>
              <g>
                <use xlink:href="#circulo-rotativo-banner" fill="none"></use>
                <text fill="#fff">
                  <textPath xlink:href="#circulo-rotativo-banner" class="rotating-text">
                    Pagamento facilitado no cartão <tspan fill="#00CF4B">•</tspan>
                  </textPath>
                </text>
              </g>
            </svg>
          </div>
      </div>
    </div><br><br>
    <section style="max-width: 90vw; margin: 0 auto!important;">
      <h2 class="title">Precisando de guincho? Estamos prontos para ajudar!</h2>
      <p>No Guincho Mais Proximo, oferecemos serviços de guincho e reboque 24 horas com rapidez, segurança e eficiência. Seja
        uma pane mecânica, pneu furado, falta de combustível ou qualquer outra emergência, nossa equipe está sempre
        disponível para atender você.</p>
    </section><br><br>
    <section style="max-width: 90vw; margin: 0 auto!important;">
    <div class="title">Conheça os
      <h3 class="title">Nossos Serviços</h3>
    </div>
    </section><br>
    <section style="margin-bottom: 100px;">
      <ul class="g4">
    <li>
        <div>
          <img width="0" height="0"  :src="require('@/assets/guincho.png')" alt="guincho 24 horas">

            <p>Atendimento 24 horas para transporte seguro do seu veículo. Chame agora e deixe todo o processo em nossas mãos.</p>
        </div>
    </li>
    <li>
        <div>
          <img width="0" height="0"  :src="require('@/assets/pneu.png')" alt="troca de pneu">
            <p>Substituímos seu pneu furado pelo estepe de forma rápida e eficiente, garantindo sua segurança sem que você precise se preocupar.</p>
        </div>
    </li>
    <li>
        <div>
          <img  width="0" height="0"  :src="require('@/assets/bateria.png')" alt="Carga de bateria">
            <p>Utilizamos equipamentos modernos e seguros para restabelecer a carga da bateria do seu veículo e colocá-lo de volta em movimento.</p>
        </div>
    </li>
    <li>
        <div>
          <img width="0" height="0"  :src="require('@/assets/pane.png')" alt="Pane Seca">
          <p>Levamos o combustível necessário para que seu veículo volte à estrada sem imprevistos. Rapidez e eficiência no seu atendimento.</p>
        </div>
    </li>
</ul>

    </section>
    <section style="max-width: 90vw; margin: 0 auto!important; display: flex; align-items: center;justify-content: center;">
     <a target="_blank"
              href="https://api.whatsapp.com/send?phone=5508006544444&amp;text=Olá%20Guincho%20Mais%20Proximo,%20Gostaria%20de%20solicitar%20um%20orçamento."
              class="btn b1">
              <img class="icon32" width="24" height="24" :src="require('@/assets/whatsapp-32.svg')" alt="whatsapp">
              CHAME NO WHATSAPP
            </a>
    </section>
    <section>
      <div>
        <a target="_blank"
          href="https://api.whatsapp.com/send?phone=5508006544444&amp;text=Olá%20Guincho%20Mais%20Proximo,%20Gostaria%20de%20solicitar%20um%20orçamento."
          class="whatsapp-button">
          <img src="@/assets/whatsapp-32.svg" alt="" width="32" height="32">
        </a>
      </div>
      <br><br><br><br>
      <footer class="footer-section">
            <div class="row">
              <div>
                <h3>Sobre Nós</h3>
                <P>A <strong>Guincho Mais Proximo</strong> é referência em remoção e transporte de veículos, oferecendo
                  atendimento rápido e seguro 24 horas por dia. Com uma equipe experiente e uma frota moderna,
                  garantimos suporte confiável em momentos de urgência. sempre prezando pela qualidade e eficiência.</P>
              </div>
              <div>
                <h3>ACEITAMOS CARTÕES</h3>
                <div style="min-width:100%; display: flex; align-items: center; justify-content: center; flex-direction: column;">
                  <img  src="@/assets/cartoes.webp" width="0" height="0" />
                </div>
                <div></div>
              </div>
              <div>
                <h3>SITE PROTEGIDO</h3>
                <div style="min-width:100%; display: flex; align-items: center; justify-content: center; flex-direction: column;">
                  <img  src="@/assets/ssl.webp" width="0" height="0" />
                </div>
                <div></div>
              </div>
            </div>
          <div class="copyright-area">
            <div>
              <p style="text-align: center">&copy; {{ year }} - Todos os direitos reservados</p>
            </div>

          </div>
      </footer>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Kanit:wght@300;400;700&display=swap');

.banner-container {
  overflow: hidden;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height:150px;
  max-width: 150px;
  top: 0;
  right:0;
  @media only screen and (max-width: 600px) {
    right:-10px;
    top: -10px;
  }
}

.rotate {
  animation: rotate 10s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
#circulo-banner::before {
    content: '';
    background-image: url("@/assets/rotacao-cartao.webp");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 50px;
    height: 50px;
    position: absolute;
    right: 0;
    left: 0;
    margin: 0 auto;
}
text {
  font-size: 19px;
  font-weight: bold;
  text-transform: uppercase;
}

* {
  overflow: hidden;
  text-decoration: none;
}
/* .btn {
    background: #D32F2F;
    color: #fff!important;
    padding: 20px 30px !important;
    border-radius: 99px;
    max-width: 20vw !important;
    min-width: 20vw !important;
    margin: 50px;
    animation: pulse 4s infinite, pisca 5s infinite;
    box-shadow: 0 0 21px -6px #D32F2F71;
} */
@keyframes pulse {
    0% {
        transform: scaleX(1)
    }

    50% {
        transform: scale3d(1.05,1.05,1.05)
    }

    to {
        transform: scaleX(1)
    }
}
@keyframes pisca {
    70% {
        box-shadow: 0 0 0 25px transparent
    }

    to {
        box-shadow: 0 0 0 0 transparent
    }
}
.slides-container {
  border-top: 15px solid #FFC107;
  position: relative;
  max-width: 100vw;
  min-width: 100vw;
  left: 0!important;
  height: 600px;
  overflow: hidden
}
.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s ease-in-out;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.slide[style*="display: block;"] {
  opacity: 1;
}
.cont {
    display: flex;
    gap:20px;
    @media only screen and (max-width: 600px) {
         display: block;
    }
  }
.g4 {
    padding: 2px !important;
    margin: 0 auto !important;
    display: grid;
    max-width: 95% !important;
    @media only screen and (max-width: 600px) {
        max-width:90%!important;
         display: block
    }
    li{
      background: #fff;
      border-radius: 20px;
      margin-bottom: 20px
    }
    P{
      padding-left: 8px;
    }
    grid-template-columns: repeat(4, calc(99% / 4));
    -moz-column-gap: 5px;
    column-gap: 5px;
    row-gap: 2.5px;
  img {
    border-radius: 20px 20px 0 0;
    max-width: 100% !important;
    min-width: 100% !important;
    width: auto;
    height: auto;
  }
}

.t {
  position: absolute;
  max-width: 60vw !important;
  left: 5%;
  top:15%;

  * {
    color: #FFF !important;
  }
  .title{
    @media only screen and (max-width: 600px) {
      font-size: 36px;
      line-height: 40px;
    }
  }
  @media only screen and (max-width: 600px) {
    left: 5%;
    max-width: 90vw !important;
    min-height: 100%;
  }
}

.font-hover {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 2.5rem;
  text-transform: uppercase;
}

.banner-contato2 {
  * {
    color: #fff !important
  }
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 20px 30px;
  margin:20px;
  border: none;
  border-radius: 36px;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
  max-width: 50vw !important;

  @media only screen and (max-width: 600px) {
    max-width: 60vw !important;
    min-width: 60vw !important;
    font-size: 0.7rem;
  }

  cursor: pointer;
}

.b1 {
  background: #00CF4B;
  color: white;
  animation: pisca 1.5s infinite;
  box-shadow: 0px 0px 21px -6px #00CF4B;
}

.b2 {
  background-color: darken(#D32F2F, 10%);
  box-shadow: 0px 0px 21px -6px #D32F2F;
  animation: pisca 1.5s infinite;
  color: white;
}

.icon32 {
  margin-right: 8px;
}

.btn:hover {
  background-color: #00CF4B
}

.btn.b2:hover {
  background-color: #D32F2F
}
.servicos{
    display: flex;
    flex-wrap: wrap;
    li {
    min-width: 45%;
    @media only screen and (max-width: 600px) {
        min-width: 100%;
    }
}
}
.footer-content{
    padding: 0 5px;
    p{
      text-align: left!important;
    }
}
.icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 18px;
    margin-right: 5px;
    color: #d5d5d5;
    font-size: 10px;
    text-align: center;
    background-color: #f3f3f6;
    vertical-align: middle;
    border-radius: 50%;
}
.row {
    display: flex;
    position: relative;
    width: 92vw;
    margin: 0 auto!important;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 6px;
    div {
       img {
         min-width: 70%!important;
         height: auto;
       }
        width: calc((100%/3) - 4px);
        @media only screen and (max-width: 600px) {
            width: 95%;
            img {
             min-width: 80%!important;
             height: auto;
       }
    }
    }
}
*{
    overflow: hidden!important;
}
h3 {
    @media only screen and (max-width: 600px) {
            font-size: 28px;
    }
    font-family: "Teko", Sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 58px;
    color:#FFC107
}
.footer-section {
    min-width: 100vw!important;
    max-width: 100vw!important;
    background: #000;
    color: #fff
}

.contact-info{
    min-width: 55%;
    margin: 0 auto!important;
    .icon-text {
    display: flex;
    margin-bottom: 10px;
    color:#fff!important;
}
}

.copyright-area {
    padding: 15px 0;
    color: #FFC107;
    text-align: center;
    div{
        margin: 0 auto!important;
    }
}
.copyright{
    display: flex;
    justify-content: center;
}
@media (max-width: 767px) {
    .footer-menu {
        margin-top: 30px;
    }
}
.whatsapp-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #00CF4B;
        width: 48px;
        height: 48px;
        padding: 20px;
        font-size: 16px;
        border-radius: 100%;
        text-decoration: none;
        animation: pulse 4s infinite, pisca 1.5s infinite;
        box-shadow: 0px 0px 21px -6px #25D366;
        // animation: pisca 1.5s infinite;
        transition: background-color 0.3s ease;
        position: fixed;
        bottom: 2vh;
        right: 5vw;
        @media only screen and (max-width: 600px) {
        }
        z-index: 1000;
    }

    .whatsapp-button:hover {
        background-color: #2aee72;
    }
</style>
